import React from 'react';
import classNames from 'classnames';
import cls from './TableHeaderReconciliation.module.css';
import { useTableHeaderReconciliation } from './useTableHeaderReconciliation';

interface TableHeaderProps {
    classes?: string;
}

export const TableHeaderReconciliation = ({ classes }: TableHeaderProps) => {
    const {} = useTableHeaderReconciliation();
    return (
        <div className={classNames(cls.TableHeader, [classes])}>
            <div className={classNames(cls.TableColumn, cls.TableName)}>
                {i18next.t('TableHeaderReconciliation.return.estimate')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableWidth)}>
                {i18next.t('TableHeaderReconciliation.return.negotiatedPrice')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableWidth)}>
                {i18next.t('TableHeaderReconciliation.return.done')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableWidth)}>
                {i18next.t('TableHeaderReconciliation.return.payed')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableWidth)}>
                {i18next.t('TableHeaderReconciliation.return.toBePaid')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableWidth)}>
                {i18next.t('TableHeaderReconciliation.return.currency')}
            </div>
        </div>
    );
};
